import React, { useEffect, useState } from "react";
import { Tabs, Button } from "antd";
import Main from "../../components/layout/Main";
import TumanentImage from "../../assets/images/tunamnet-tubhnail-image.jpg";
import GamesImage from "../../assets/images/games-image.jpg";
import TrofiesImage from "../../assets/images/trofies-image.svg";
import { useNavigate } from "react-router";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTournament } from "../../context/TournamentContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useSubscription } from "../../context/SubscriptionContext";
import moment from "moment";
import { getDiff, isValidUrl } from "../../helper/functions";
import { ImageNotAvailable } from "../../constants/urls";
import { useAuth } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";
const PrivateTournaments = () => {
  const [tournaments, setTournaments] = useState([]);
  const [tournamentStatus, setTournamentStatus] = useState("Upcoming");
  const [profile, setProfile] = useState();
  const { getProfile } = useAuth();
  // const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [games, setGames] = useState([]);
  const Navigate = useNavigate();
  const { loadTournaments, filters, updateFilters, loadGames } =
    useTournament();
  // ----------   handlers   -----------
  const fetchTournaments = async (params = {}) => {
    const profileData = await getProfile();
    if (profileData.status === 200) {
      setProfile(profileData.data);
    }

    const response = await loadTournaments(params);
    if (response.status === 200) {
      setTournaments(response.data.data.tournaments);
    }
    const result = await loadGames();
    if (result.status === 200) {
      setGames(result.data.data.uncategorizedGames);
    }
  };

  // ---------- use effects ----------
  useEffect(() => {
    const params = { type: "private", status: tournamentStatus, game: "" };
    updateFilters(params);
    fetchTournaments(params);
  }, [tournamentStatus]);

  return (
    <Main>
      <div className="section-headding">
        <h6>Private Tournaments</h6>
        <div className="create-btn-header">
          <Button
            className="private-tunament-button Fill-button"
            onClick={() => {
              if (profile.isSubscribed) {
                Navigate("/create-private-tournament");
              } else {
                ShowToast(
                  "You can't create private tournament. Kindly subscribe our plan",
                  Severty.ERROR
                );
              }
            }}
          >
            Create Private Tournament
          </Button>
        </div>
      </div>
      <div className="home-container">
        <Section
          title="Browse by Games"
          data={games}
          type="game"
          navigate={Navigate}
          profile={profile}
          tournamentStatus={tournamentStatus}
        />
        <div className="game-modes-filter mt-3">
          {["Active", "Upcoming", "Completed"].map((status) => (
            <Button
              key={status}
              type={tournamentStatus === status ? "primary" : "default"}
              onClick={() => setTournamentStatus(status)}
              className="mode-filter-btn"
            >
              {status}
            </Button>
          ))}
        </div>

        <Section
          data={tournaments}
          type="tournament"
          navigate={Navigate}
          profile={profile}
          tournamentStatus={tournamentStatus}
        />
      </div>
    </Main>
  );
};

const Section = ({
  title,
  data,
  type,
  navigate,
  profile,
  tournamentStatus,
}) => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 4, // ek time me 4 item
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024, // tablet
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // mobile
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="section-block">
      {type === "tournament" ? (
        <>
          <div className="section-header">
            <div className="orange-header">{title}</div>
          </div>
          <div className="main-grid-class ">
            {data && data.length > 0 ? (
              data.map((item, index) => (
                <div key={index} className={`tournament-card`}>
                  <div
                    className={` ${
                      !profile?.isSubscribed ? "tournament-upgrade-card" : ""
                    }`}
                  >
                    <div className="tunament-image">
                      <img
                        alt="thumbnail"
                        src={
                          isValidUrl(item.game.image)
                            ? item?.game?.image
                            : ImageNotAvailable
                        }
                      />
                    </div>

                    <div className="card-top-info">
                      <div className="tunament-date">
                        {moment(item.startDate).format("DD MMM YYYY | HH:mm A")}
                      </div>
                      <div className="starts-time">
                        <span>{getDiff(item.startDate, new Date())}</span>
                      </div>
                    </div>
                    <div className="card-tags">
                      {/* <img src={TrofiesImage} alt="Trophies" /> */}
                      <span>{item.name_en}</span>
                    </div>

                    <div className="card-tags-item1">
                      <img src={TrofiesImage} alt="Trophies" />
                      {item &&
                        item?.trophyStructure?.map((trophy, index) => (
                          <span>{trophy}</span>
                        ))}
                    </div>

                    <div className="tunament-slot">{`${
                      item.totalRegisteredPlayers
                    }/ ${
                      item?.teamSize *
                      (item.totalPlayerSize > 0 ? item.totalPlayerSize : 1)
                    } slots`}</div>
                  </div>

                  <div className="brouse-game-live-btn">
                    {/* ❌ NOT SUBSCRIBED → Show only Subscribe button */}
                    {!profile?.isSubscribed && (
                      <>
                        <Button
                          className="join-button Fill-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/subscriptions");
                          }}
                        >
                          Upgrade To Premium
                        </Button>
                        {tournamentStatus === "Upcoming" && (
                          <Button
                            className="join-button Fill-button"
                            onClick={() =>
                              navigate(
                                `/private-tournaments/tournaments-details/${item._id}`
                              )
                            }
                          >
                            Play via token
                          </Button>
                        )}
                      </>
                    )}

                    {/* ✅ SUBSCRIBED → Show normal tournament buttons */}
                    {profile?.isSubscribed && (
                      <>
                        {/* Creator & NO bracket → Create Bracket */}
                        {item.isCreator && !item.bracketGenerated && (
                          <Button
                            className="bid-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(
                                `/private-tournaments/create-bracket/${item._id}`
                              );
                            }}
                          >
                            Create Bracket
                          </Button>
                        )}

                        {/* Creator & bracket generated → Brackets */}
                        {item.isCreator && item.bracketGenerated && (
                          <Button
                            className="bid-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(
                                `/private-tournaments/brackets/${item._id}`
                              );
                            }}
                          >
                            Brackets
                          </Button>
                        )}

                        {/* Not creator → View Bracket */}
                        {!item.isCreator && (
                          <Button
                            className="bid-button"
                            onClick={() =>
                              navigate(
                                `/private-tournaments/tournaments-details/${item._id}`
                              )
                            }
                          >
                            View Bracket
                          </Button>
                        )}

                        {/* Not creator → Join Tournament */}
                        {!item.isCreator && (
                          <Button
                            className="join-button Fill-button"
                            onClick={() =>
                              navigate(
                                `/private-tournaments/tournaments-details/${item._id}`
                              )
                            }
                          >
                            Join Tournament
                          </Button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p className="private-tournamnet-no-data-found-text">
                No Private Tournaments Found
              </p>
            )}
          </div>
        </>
      ) : type === "game" ? (
        <>
          <div className="section-header">
            <div className="orange-header">{title}</div>
            <span
              className="view-all"
              onClick={() => navigate("/private-tournaments/games")}
            >
              {data && " View All "}
            </span>
          </div>
          <div className="browse-game-slide">
            {data && data.length > 0 ? (
              <Swiper
                modules={[Navigation]}
                navigation={true}
                loop={true}
                speed={500}
                spaceBetween={20}
                breakpoints={{
                  480: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                  1200: { slidesPerView: 4 },
                }}
              >
                {data?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="game-card"
                      // onClick={() => navigate("/private-tournaments/games")}
                      onClick={() =>
                        navigate(
                          `/private-tournaments/games/${item?.game?.name}?tab=${tournamentStatus}`
                        )
                      }
                    >
                      <img
                        src={
                          isValidUrl(item.game.image)
                            ? item.game.image
                            : ImageNotAvailable
                        }
                        alt="Game"
                        className="game-image"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="no-games-available">
                <p>No games available</p>
              </div>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default PrivateTournaments;
